"use client"

import { useState, useContext, useEffect } from "react"
import { ErpContext } from "../../context/ErpContext.js"
import {
  TextField,
  Button,
  Container,
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Tabs,
  Tab,
  Paper,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  Autocomplete,
  Collapse,
  Chip,
  IconButton,
} from "@mui/material"
import {
  Person as PersonIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  LocationOn as LocationIcon,
  Badge as BadgeIcon,
  Business as BusinessIcon,
  Add as AddIcon,
  List as ListIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
  Settings as SettingsIcon,
} from "@mui/icons-material"
import TablaEntidadComponent from "./TablaEntidadComponent.js"
import FormularioEntidadComponent from "./FormularioEntidadComponent.js"
import GestionEntidadAtributo from "./EntidadAtributoComponent.js"
import Swal from "sweetalert2"
import withReactContent from "sweetalert2-react-content"

function TabPanel({ children, value, index, sx = {}, ...other }) {
  const defaultSx = { p: { xs: 2, sm: 3, md: 4 } }
  const mergedSx = sx?.p !== undefined && sx?.p === 0 
    ? { ...defaultSx, ...sx, p: 0 } 
    : { ...defaultSx, ...sx }
  
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={{ 
        height: "100%", 
        display: value === index ? "flex" : "none", 
        flexDirection: "column",
        width: "100%",
      }}
      {...other}
    >
      {value === index && <Box sx={mergedSx}>{children}</Box>}
    </div>
  )
}

const GestionEntidadComponent = () => {
  const { 
    tipoEntidades, 
    getTipoEntidad, 
    postEntidad, 
    condicionIva, 
    getCondicionIva, 
    isNavbarCollapsed,
    getEntidad,
    entidadAtributoNoEliminados,
    getEntidadAtributoNoEliminados,
    getEntidadAtributoClasificacionByIdAtributo,
  } = useContext(ErpContext)

  // Estados para formulario de crear
  const [descripcionEntidad, setDescripcionEntidad] = useState("")
  const [apellidoEntidad, setApellidoEntidad] = useState("")
  const [telefonoEntidad, setTelefonoEntidad] = useState("")
  const [emailEntidad, setEmailEntidad] = useState("")
  const [dniCuitCuilEntidad, setdniCuitCuilEntidad] = useState("")
  const [direccionEntidad, setDireccionEntidad] = useState("")
  const [localidadEntidad, setLocalidadEntidad] = useState("")
  const [provinciaEntidad, setProvinciaEntidad] = useState("")
  const [idTipoEntidadEntidad, setIdTipoEntidadEntidad] = useState("")
  const [idCondicionIvaEntidad, setIdCondicionIvaEntidad] = useState("")

  const [tabValue, setTabValue] = useState(0)
  const [showSuccess, setShowSuccess] = useState(false)
  const [errors, setErrors] = useState({})

  // Estados para atributos
  const [atributosForm, setAtributosForm] = useState([])
  const [expandedAtributos, setExpandedAtributos] = useState(true)
  const [atributosErrors, setAtributosErrors] = useState({})
  const [opcionesPorAtributo, setOpcionesPorAtributo] = useState({}) // { idAtributo: [opciones] }
  const [atributosDisponibles, setAtributosDisponibles] = useState([]) // Estado local para atributos del tipo

  // Estados para tabla y paginación
  const [entidades, setEntidades] = useState([])
  const [searchText, setSearchText] = useState("")
  const [idTipoEntidadFilter, setIdTipoEntidadFilter] = useState("")
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(false)

  // Paginación del servidor
  const [page, setPage] = useState(1)
  const [rowsPerPage] = useState(100)
  const [totalPages, setTotalPages] = useState(1)
  const [totalCount, setTotalCount] = useState(0)

  // Estados para filtros de atributos
  const [filtrosAtributos, setFiltrosAtributos] = useState({})

  useEffect(() => {
    getTipoEntidad()
    getCondicionIva()
    // No cargar atributos aquí, se cargarán cuando se seleccione el tipo de entidad
    // Cargar datos iniciales
    fetchEntidades()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Cargar opciones para cada atributo
  const cargarOpcionesAtributos = async (atributosParam = null, idTipoEntidadParam = null) => {
    const atributosAUsar = atributosParam || atributosDisponibles
    const idTipoEntidad = idTipoEntidadParam || idTipoEntidadEntidad
    
    if (!atributosAUsar || atributosAUsar.length === 0) {
      setOpcionesPorAtributo({})
      return
    }

    if (!idTipoEntidad) {
      console.warn('idTipoEntidad no disponible para cargar opciones de atributos')
      setOpcionesPorAtributo({})
      return
    }

    const opcionesMap = {}
    for (const attr of atributosAUsar) {
      try {
        const opciones = await getEntidadAtributoClasificacionByIdAtributo(attr.idEntidadAtributo || attr.id, idTipoEntidad)
        opcionesMap[attr.idEntidadAtributo || attr.id] = opciones || []
      } catch (error) {
        console.error(`Error al cargar opciones para atributo ${attr.idEntidadAtributo || attr.id}:`, error)
        opcionesMap[attr.idEntidadAtributo || attr.id] = []
      }
    }
    setOpcionesPorAtributo(opcionesMap)
  }

  // Recargar atributos cuando cambia el tipo de entidad seleccionado
  useEffect(() => {
    const cargarAtributosPorTipo = async () => {
      if (idTipoEntidadEntidad) {
        // Cargar atributos específicos del tipo seleccionado
        const atributos = await getEntidadAtributoNoEliminados(idTipoEntidadEntidad)
        setAtributosDisponibles(atributos || [])
        
        // Cargar opciones de clasificación
        if (atributos && atributos.length > 0) {
          await cargarOpcionesAtributos(atributos, idTipoEntidadEntidad)
          
          // Inicializar valores (todos null para nueva entidad)
          const inicial = atributos.map((attr) => ({
            id: attr.idEntidadAtributo || attr.id,
            descripcion: attr.descripcion,
            valor: null,
          }))
          setAtributosForm(inicial)
          setAtributosErrors({})
          setExpandedAtributos(true)
        } else {
          // Si no hay atributos, limpiar el formulario
          setAtributosForm([])
          setAtributosErrors({})
          setOpcionesPorAtributo({})
        }
      } else {
        // Si no hay tipo seleccionado, limpiar
        setAtributosDisponibles([])
        setAtributosForm([])
        setAtributosErrors({})
        setOpcionesPorAtributo({})
      }
    }
    
    cargarAtributosPorTipo()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idTipoEntidadEntidad])

  // Función para obtener entidades con paginación del servidor
  const fetchEntidades = async (filtrosAtributosParam = filtrosAtributos) => {
    setLoading(true)
    setError(null)
    try {
      const response = await getEntidad(page, rowsPerPage, searchText, filtrosAtributosParam, idTipoEntidadFilter || null)
      if (response && response.data) {
        // Respuesta con estructura de paginación
        setEntidades(response.data)
        setTotalPages(response.totalPages || 1)
        setTotalCount(response.total || 0)
      } else {
        // Mantener compatibilidad con respuestas antiguas
        setEntidades(response || [])
        setTotalPages(1)
        setTotalCount(response?.length || 0)
      }
    } catch (err) {
      console.error("Error al cargar Entidades:", err)
      setError("No se pudieron cargar las Entidades. Intente nuevamente.")
    } finally {
      setLoading(false)
    }
  }

  // Efecto para recargar cuando cambia el filtro de tipo de entidad (sin debounce)
  useEffect(() => {
    setPage(1)
    const fetchData = async () => {
      setLoading(true)
      setError(null)
      try {
        const response = await getEntidad(1, rowsPerPage, searchText, {}, idTipoEntidadFilter || null)
        if (response && response.data) {
          setEntidades(response.data)
          setTotalPages(response.totalPages || 1)
          setTotalCount(response.total || 0)
        } else {
          setEntidades(response || [])
          setTotalPages(1)
          setTotalCount(response?.length || 0)
        }
      } catch (err) {
        console.error("Error al cargar Entidades:", err)
        setError("No se pudieron cargar las Entidades. Intente nuevamente.")
      } finally {
        setLoading(false)
      }
    }
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idTipoEntidadFilter])

  // Debounce para el buscador
  useEffect(() => {
    // Resetear página cuando cambia el texto de búsqueda
    setPage(1)
    
    // Crear un timer para debounce
    const timer = setTimeout(() => {
      const fetchData = async () => {
        setLoading(true)
        setError(null)
        try {
          const response = await getEntidad(1, rowsPerPage, searchText, {}, idTipoEntidadFilter || null)
          if (response && response.data) {
            setEntidades(response.data)
            setTotalPages(response.totalPages || 1)
            setTotalCount(response.total || 0)
          } else {
            setEntidades(response || [])
            setTotalPages(1)
            setTotalCount(response?.length || 0)
          }
        } catch (err) {
          console.error("Error al cargar Entidades:", err)
          setError("No se pudieron cargar las Entidades. Intente nuevamente.")
        } finally {
          setLoading(false)
        }
      }
      fetchData()
    }, 500) // Esperar 500ms después de que el usuario deje de escribir

    // Limpiar el timer si el usuario sigue escribiendo
    return () => clearTimeout(timer)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText])

  // Efecto para recargar datos cuando cambia la página
  useEffect(() => {
    fetchEntidades()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page])

  // Manejar cambio de página (CustomPagination usa página 1-indexed)
  const handleChangePage = (newPage) => {
    setPage(newPage)
  }

  const validateForm = () => {
    const newErrors = {}
    const newAtributosErrors = {}

    if (!descripcionEntidad.trim()) {
      newErrors.descripcion = "El nombre es requerido"
    }

    if (!dniCuitCuilEntidad.trim()) {
      newErrors.dniCuitCuil = "El DNI/CUIT/CUIL es requerido"
    }

    if (emailEntidad && !/\S+@\S+\.\S+/.test(emailEntidad)) {
      newErrors.email = "Email inválido"
    }

    if (!idTipoEntidadEntidad) {
      newErrors.idTipoEntidad = "Debe seleccionar un tipo de entidad"
    }

    if (atributosForm && atributosForm.length > 0) {
      atributosForm.forEach((attr) => {
        if (attr.valor === null || attr.valor === undefined) {
          newAtributosErrors[attr.id] = "Selecciona un valor para este atributo"
        }
      })
    }

    setErrors(newErrors)
    setAtributosErrors(newAtributosErrors)
    return Object.keys(newErrors).length === 0 && Object.keys(newAtributosErrors).length === 0
  }

  const resetForm = () => {
    setDescripcionEntidad("")
    setApellidoEntidad("")
    setTelefonoEntidad("")
    setEmailEntidad("")
    setdniCuitCuilEntidad("")
    setDireccionEntidad("")
    setLocalidadEntidad("")
    setProvinciaEntidad("")
    setIdTipoEntidadEntidad("")
    setIdCondicionIvaEntidad("")
    setErrors({})
    setAtributosErrors({})
    // Resetear atributos
    if (entidadAtributoNoEliminados?.length > 0) {
      const resetAtributos = entidadAtributoNoEliminados.map((attr) => ({
        id: attr.id,
        descripcion: attr.descripcion,
        valor: null,
      }))
      setAtributosForm(resetAtributos)
    } else {
      setAtributosForm([])
    }
    setExpandedAtributos(true)
  }

  // Manejar cambio en atributos
  const handleAtributoFormChange = (id, valor) => {
    // Convertir string vacío a null
    const valorFinal = valor === "" || valor === null ? null : (typeof valor === 'string' ? parseInt(valor) || null : valor)
    setAtributosForm((prev) => prev.map((attr) => (attr.id === id ? { ...attr, valor: valorFinal } : attr)))
    setAtributosErrors((prev) => {
      if (!prev[id]) return prev
      const { [id]: _, ...rest } = prev
      return rest
    })
  }

  const handleEntidadSubmit = async (e) => {
    e.preventDefault()

    if (!validateForm()) {
      return
    }

    try {
      await postEntidad(
        descripcionEntidad,
        apellidoEntidad,
        telefonoEntidad,
        emailEntidad,
        dniCuitCuilEntidad,
        direccionEntidad,
        localidadEntidad,
        provinciaEntidad,
        idTipoEntidadEntidad,
        idCondicionIvaEntidad,
        atributosForm,
      )

      resetForm()
      setShowSuccess(true)
      setTimeout(() => setShowSuccess(false), 3000)
      SucessModal()
      // Actualizar lista de entidades después de crear
      await fetchEntidades()
    } catch (error) {
      console.error("Error al crear entidad:", error)
      ErrorModal(error.message || "Error en CREAR la entidad")
    }
  }

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue)
  }

  const ErrorModal = (mensaje = "Error en CREAR la entidad") => {
    withReactContent(Swal).fire({
      position: "bottom-end",
      icon: "error",
      text: mensaje,
      showConfirmButton: false,
      timer: 5000,
      width: 400,
    })
  }

  const SucessModal = () => {
    withReactContent(Swal).fire({
      position: "bottom-end",
      icon: "success",
      text: "Se CREO la entidad correctamente",
      showConfirmButton: false,
      timer: 3000,
      width: 300,
    })
  }

  return (
    <Box 
      key={isNavbarCollapsed ? "collapsed" : "expanded"}
      sx={{ 
        height: "100%", 
        display: "flex", 
        flexDirection: "column", 
        overflow: "hidden",
        p: { xs: 1, sm: 1.5, md: 2 },
        minHeight: 0,
        width: "100%",
      }}
    >
      <Paper 
        elevation={0} 
        sx={{ 
          borderRadius: 2, 
          overflow: "hidden", 
          display: "flex", 
          flexDirection: "column", 
          flex: 1, 
          minHeight: 0,
          width: "100%",
        }}
      >
        <Box sx={{ borderBottom: 1, borderColor: "divider", bgcolor: "#f8f9fa", flexShrink: 0 }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            sx={{
              "& .MuiTab-root": {
                color: "#5b5b5f",
                fontWeight: 600,
                textTransform: "none",
                fontSize: "16px",
                minHeight: "60px",
                "&.Mui-selected": {
                  color: "#5b5b5f",
                },
              },
              "& .MuiTabs-indicator": {
                backgroundColor: "#5b5b5f",
                height: 3,
              },
            }}
          >
            <Tab icon={<ListIcon />} label="Gestionar Entidades" iconPosition="start" sx={{ mr: 2 }} />
            <Tab icon={<SettingsIcon />} label="Atributos de Entidad" iconPosition="start" sx={{ mr: 2 }} />
            <Tab icon={<AddIcon />} label="Crear Entidad" iconPosition="start" />
          </Tabs>
        </Box>

        <Box 
          sx={{ 
            flex: 1, 
            overflow: "hidden", 
            display: "flex", 
            flexDirection: "column", 
            minHeight: 0,
            width: "100%",
          }}
        >
          <TabPanel 
            value={tabValue} 
            index={0} 
            sx={{ 
              flex: 1, 
              display: "flex", 
              flexDirection: "column", 
              overflow: "hidden", 
              p: 0,
              minHeight: 0,
              maxHeight: "100%",
              width: "100%",
            }}
          >
            <TablaEntidadComponent
              key={`tabla-${isNavbarCollapsed ? "collapsed" : "expanded"}`}
              entidades={entidades}
              searchText={searchText}
              setSearchText={setSearchText}
              idTipoEntidadFilter={idTipoEntidadFilter}
              setIdTipoEntidadFilter={setIdTipoEntidadFilter}
              tipoEntidades={tipoEntidades}
              loading={loading}
              error={error}
              setError={setError}
              success={success}
              setSuccess={setSuccess}
              page={page}
              totalPages={totalPages}
              totalCount={totalCount}
              handleChangePage={handleChangePage}
              fetchEntidades={fetchEntidades}
              filtrosAtributos={filtrosAtributos}
              setFiltrosAtributos={setFiltrosAtributos}
            />
          </TabPanel>

          <TabPanel 
            value={tabValue} 
            index={1} 
            sx={{ overflow: "auto", height: "100%" }}
          >
            <Card elevation={2} sx={{ borderRadius: 2, maxWidth: 1400, mx: "auto", width: "100%", my: 2 }}>
              <CardContent sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
                <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
                  <SettingsIcon sx={{ color: "#5b5b5f", mr: 2, fontSize: 28 }} />
                  <Typography variant="h5" sx={{ color: "#5b5b5f", fontWeight: 600 }}>
                    Gestión de Atributos de Entidad
                  </Typography>
                </Box>
                <GestionEntidadAtributo />
              </CardContent>
            </Card>
          </TabPanel>

          <TabPanel value={tabValue} index={2} sx={{ overflow: "auto", height: "100%" }}>
            <Card elevation={2} sx={{ borderRadius: 2, maxWidth: 900, mx: "auto", width: "100%", my: 2 }}>
              <CardContent sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
                <BusinessIcon sx={{ color: "#5b5b5f", mr: 2, fontSize: 28 }} />
                <Typography variant="h5" sx={{ color: "#5b5b5f", fontWeight: 600 }}>
                  Nueva Entidad
                </Typography>
              </Box>

              {showSuccess && (
                <Alert severity="success" sx={{ mb: 3, borderRadius: 2 }}>
                  ¡Entidad creada exitosamente!
                </Alert>
              )}

              <form onSubmit={handleEntidadSubmit}>
                <FormularioEntidadComponent
                  descripcionEntidad={descripcionEntidad}
                  setDescripcionEntidad={setDescripcionEntidad}
                  apellidoEntidad={apellidoEntidad}
                  setApellidoEntidad={setApellidoEntidad}
                  dniCuitCuilEntidad={dniCuitCuilEntidad}
                  setdniCuitCuilEntidad={setdniCuitCuilEntidad}
                  telefonoEntidad={telefonoEntidad}
                  setTelefonoEntidad={setTelefonoEntidad}
                  emailEntidad={emailEntidad}
                  setEmailEntidad={setEmailEntidad}
                  direccionEntidad={direccionEntidad}
                  setDireccionEntidad={setDireccionEntidad}
                  localidadEntidad={localidadEntidad}
                  setLocalidadEntidad={setLocalidadEntidad}
                  provinciaEntidad={provinciaEntidad}
                  setProvinciaEntidad={setProvinciaEntidad}
                  idTipoEntidadEntidad={idTipoEntidadEntidad}
                  setIdTipoEntidadEntidad={setIdTipoEntidadEntidad}
                  idCondicionIvaEntidad={idCondicionIvaEntidad}
                  setIdCondicionIvaEntidad={setIdCondicionIvaEntidad}
                  tipoEntidades={tipoEntidades}
                  condicionIva={condicionIva}
                  errors={errors}
                  showCondicionIva={true}
                  compact={false}
                />

                {/* Sección de Atributos - siempre visible */}
                {atributosForm && atributosForm.length > 0 && (
                  <Box sx={{ mt: 3 }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        cursor: "default",
                        p: 1.5,
                        borderRadius: 1,
                        backgroundColor: "#f5f5f5",
                        "&:hover": {
                          backgroundColor: "#f5f5f5",
                        },
                      }}
                    >
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Divider sx={{ flex: 1, maxWidth: 200 }}>
                          <Chip 
                            label="Atributos de la Entidad" 
                            variant="outlined" 
                            sx={{ 
                              fontWeight: 500, 
                              color: '#5b5b5f',
                              border: '1px solid #5b5b5f',
                            }} 
                          />
                        </Divider>
                      </Box>
                      <IconButton size="small" disabled>
                        <ExpandLessIcon />
                      </IconButton>
                    </Box>
                    <Collapse in={expandedAtributos} timeout="auto" unmountOnExit={false}>
                      <Grid container spacing={2} sx={{ mt: 1, p: 2 }}>
                        {atributosForm.map((attr) => {
                          const opciones = opcionesPorAtributo[attr.id] || []
                          const attrError = atributosErrors[attr.id]
                          return (
                            <Grid item xs={12} sm={6} md={4} lg={3} key={attr.id}>
                              <Autocomplete
                                size="small"
                                disablePortal
                                options={opciones}
                                getOptionLabel={(option) => option.descripcion || ""}
                                value={opciones.find(o => o.id === attr.valor) || null}
                                onChange={(event, newValue) => {
                                  handleAtributoFormChange(attr.id, newValue ? newValue.id : null)
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label={attr.descripcion}
                                    error={!!attrError}
                                    helperText={attrError}
                                    required
                                    sx={{
                                      borderRadius: 2,
                                      "& .MuiOutlinedInput-root": {
                                        borderRadius: 2,
                                        "&:hover .MuiOutlinedInput-notchedOutline": {
                                          borderColor: "#5b5b5f",
                                        },
                                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                          borderColor: "#5b5b5f",
                                        },
                                      },
                                      "& .MuiInputLabel-root.Mui-focused": {
                                        color: "#5b5b5f",
                                      },
                                    }}
                                  />
                                )}
                              />
                            </Grid>
                          )
                        })}
                      </Grid>
                    </Collapse>
                  </Box>
                )}

                <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 3 }}>
                  <Button
                    variant="outlined"
                    onClick={resetForm}
                    sx={{
                      borderColor: "#5b5b5f",
                      color: "#5b5b5f",
                      "&:hover": {
                        borderColor: "#5b5b5f",
                        backgroundColor: "rgba(91, 91, 95, 0.04)",
                      },
                    }}
                  >
                    Limpiar
                  </Button>
                  <Button
                    variant="contained"
                    type="submit"
                    startIcon={<AddIcon />}
                    sx={{
                      backgroundColor: "#5b5b5f",
                      "&:hover": {
                        backgroundColor: "#4a4a4e",
                      },
                      px: 4,
                    }}
                  >
                    Crear Entidad
                  </Button>
                </Box>
              </form>
              </CardContent>
            </Card>
          </TabPanel>
        </Box>
      </Paper>
    </Box>
  )
}

export default GestionEntidadComponent
